<div *ngIf="isThemeLight" class="tooltip-arrow"></div>

<div [innerHTML]="value"></div>
